import React, { useState, useEffect } from 'react';
import { database } from '../firebase';
import { ref, get, update } from 'firebase/database';

const AdminRebuildPreguntasPorTema = () => {
    const [status, setStatus] = useState('idle');
    const [progress, setProgress] = useState({ current: 0, total: 0 });
    const [log, setLog] = useState([]);
    const [existingTemas, setExistingTemas] = useState([]);

    useEffect(() => {
        const checkExisting = async () => {
            try {
                const snap = await get(ref(database, 'preguntas_por_tema'));
                if (snap.exists()) {
                    setExistingTemas(Object.keys(snap.val()));
                }
            } catch (e) {
                console.error('Error checking existing temas:', e);
            }
        };
        checkExisting();
    }, []);

    const addLog = (msg) => setLog(prev => [...prev, msg]);

    const handleRebuild = async () => {
        setStatus('running');
        setLog([]);
        addLog('📥 Cargando simulador.json...');

        try {
            const response = await fetch('/data/simulador.json');
            if (!response.ok) throw new Error(`HTTP ${response.status}: No se pudo cargar simulador.json`);
            const data = await response.json();
            const preguntas = data.preguntas || [];
            addLog(`✅ Cargadas ${preguntas.length} preguntas del archivo.`);

            // Agrupar por tema_id
            const byTema = {};
            preguntas.forEach(q => {
                const tid = String(q.tema_id);
                if (!byTema[tid]) byTema[tid] = [];
                byTema[tid].push(q);
            });

            const existingSet = new Set(existingTemas);
            const missingTemas = Object.keys(byTema).filter(tid => !existingSet.has(tid));

            if (missingTemas.length === 0) {
                addLog('⚠️ Todos los temas ya existen en preguntas_por_tema.');
                setStatus('done');
                return;
            }

            addLog(`📦 Temas a procesar (${missingTemas.length}): [${missingTemas.join(', ')}]`);
            addLog(`⏭️ Temas existentes omitidos: [${existingTemas.join(', ')}]`);

            const totalPendientes = missingTemas.reduce((sum, tid) => sum + byTema[tid].length, 0);
            addLog(`📊 Total preguntas a subir: ${totalPendientes}`);
            setProgress({ current: 0, total: totalPendientes });

            let processed = 0;

            for (const temaId of missingTemas) {
                const questions = byTema[temaId];
                addLog(`   → Tema ${temaId}: ${questions.length} preguntas...`);

                // Batch por tema para rendimiento
                const updates = {};
                questions.forEach(q => {
                    const key = `q_${q.id}`;
                    updates[`preguntas_por_tema/${temaId}/${key}`] = {
                        pregunta: q.pregunta,
                        respuestas: q.respuestas,
                        tema_id: parseInt(temaId)
                    };
                });

                await update(ref(database), updates);
                processed += questions.length;
                setProgress({ current: processed, total: totalPendientes });
                addLog(`   ✅ Tema ${temaId} completado (${questions.length} preguntas)`);
            }

            addLog(`\n✅ PROCESO COMPLETADO. ${processed} preguntas subidas a preguntas_por_tema.`);
            addLog('🔄 Recarga el Simulador para ver los cambios.');
            setStatus('done');
        } catch (error) {
            addLog(`❌ Error: ${error.message}`);
            setStatus('error');
        }
    };

    return (
        <div className="admin-panel-section" style={{ padding: '20px' }}>
            <h2>Migrar preguntas a preguntas_por_tema</h2>
            <p style={{ color: '#aaa', marginBottom: '15px' }}>
                Lee <code>public/data/simulador.json</code> (1,490 preguntas) y sube las de los temas que
                faltan al nodo <code>preguntas_por_tema</code> de la RTDB para que el Simulador las
                reconozca con su <code>tema_id</code> correcto.
            </p>

            <div style={{
                background: '#0f2438', borderRadius: '8px', padding: '15px', marginBottom: '15px',
                border: '1px solid #333'
            }}>
                <strong>Temas existentes en preguntas_por_tema:</strong>
                <span style={{ marginLeft: '10px', color: existingTemas.length > 0 ? '#4CAF50' : '#888' }}>
                    {existingTemas.length > 0 ? `[${existingTemas.join(', ')}]` : 'Verificando...'}
                </span>
            </div>

            <button
                onClick={handleRebuild}
                disabled={status === 'running'}
                 style={{  marginBottom: '20px'
                 }} className="adm-btn adm-btn--secondary"
            >
                {status === 'running'
                    ? `Subiendo ${progress.current}/${progress.total}...`
                    : '🚀 Migrar preguntas faltantes a preguntas_por_tema'}
            </button>

            {log.length > 0 && (
                <div style={{
                    background: '#0d1117', borderRadius: '8px', padding: '15px',
                    maxHeight: '400px', overflowY: 'auto',
                    fontFamily: 'monospace', fontSize: '13px', lineHeight: '1.6'
                }}>
                    {log.map((msg, i) => (
                        <div key={i} style={{
                            color: msg.includes('✅') ? '#4CAF50' :
                                   msg.includes('❌') ? '#ff6b6b' :
                                   msg.includes('⚠️') ? '#ffc107' :
                                   msg.includes('📦') ? '#64b5f6' :
                                   '#ccc',
                            whiteSpace: 'pre-wrap'
                        }}>{msg}</div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AdminRebuildPreguntasPorTema;
